if ($(".ordering-process").length) {



  function newFooter() {
    if ($(".id--16").length) {
      var textTop = $("#shipping-4 .shipping-billing-name").text().split(" - ")[0];
      var bottomText = $("#shipping-4 .shipping-billing-name").text().split(" - ")[1];
      $("#shipping-4 .shipping-billing-name").html('<span class="topText">' + textTop + "</span>");
      $("#shipping-4 .payment-info").append('<span class="bottomText">' + bottomText + "</span>");
      $("#shipping-4 .payment-info").append('<div class="mapLink"><span class="dataMap" data-href="https://maps.app.goo.gl/5kcdCaprgsedJd8u5" target="_blank">Zobrazit na mapě</span></div>');



      const maxDate = localStorage.getItem("maxDeliveryDate");


    }
    $(".responsive-tools").append($("footer#footer .heurekaHeader"));

    if ($(".id--9").length) {
      if ($(".cart-empty").length) {
        emptyCart();
      }
      document.addEventListener("ShoptetDOMContentLoaded", function () {
        if ($(".cart-empty").length) {
          emptyCart();
        }
      });
    }

    if ($(".id--15.in-dekujeme").length) {
      document.addEventListener("UpsellBannersRendered", function () {
        $("html").on("click", ".up-banner-thankYou-bottom button.up-banner-link", function () {
          if ($(this).attr("data-url").length) {
            window.location.href = $(this).attr("data-url");
          } else {
          }
        });
      });

      $('.recapitulation-wrapper[data-testid="recapTable"]').after($("#footer .recenze.in-dekujeme").clone());
      $(".content-inner .in-dekujeme.recenze").after("<div class='dekujeme_bnts'><a href=\"/\" class='btn btn-default goBack'>Zpět do obchodu</a><div class='socials'></div></div>");
      $(".dekujeme_bnts .socials").append($("#footer .fanAndCertifikate .fan").clone());
      $(".fan ul.fanList").append($("footer#footer .contact-box span.facebook").closest("li").clone(), $("footer#footer .contact-box span.instagram").closest("li").clone(), $("footer#footer .contact-box span.youtube").closest("li").clone(), $("footer#footer .contact-box span.tiktok").closest("li").clone());
    }
    const storageKey = "storeRatingData-" + document.location.host;
    const stored = sessionStorage.getItem(storageKey);

    if (stored) {
      let parsed = JSON.parse(stored);
      if (typeof parsed === "string") {
        parsed = JSON.parse(parsed);
      }
      const score = Math.round((parseFloat(parsed.averageScore) / 5) * 100);
      $(".heurekaHeader .customersPercentil").text(score + "%");
    }
  }

  $(document).ready(function () {
    loadFooter(newFooter);
  });
}

if ($(".id--17").length) {
  $('input[name="vatId"]').removeAttr("placeholder");
  var $checkoutInputs = $('.id--17 input[type="text"], .id--17 input[type="email"], .id--17 input[type="password"], .id--17 input[type="tel"]');
  $checkoutInputs.each(function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  $checkoutInputs.on("click focus", function () {
    $(this).closest(".form-group").addClass("focused");
  });

  $checkoutInputs.on("blur", function () {
    $(this).closest(".form-group").toggleClass("focused", !!$(this).val());
  });

  if (getShoptetDataLayer("customer").registered) {
  } else {
    $(".co-contact-information").prepend(`
            <div class="customLogin">
                    <p>Máte u nás účet? Přihlaste se, údaje se vyplní automaticky.
                  <span class="customLoginPopup">Přihlásit se</span></p>
        
            </div>
        `);

  }
}

if ($(".id--16, .id--17").length) {
  $(".cart-inner").prepend($(".cart-header"));

  $("#checkoutSidebar").append($(".next-step .next-step-back").clone());

  $.get("/action/Cart/GetCartContent/?orderingProcessActive=1", function (data) {
    $('.cart-item[data-micro="cartItem"]').each(function () {
      get_id = $(this).attr("data-micro-sku");
      var $row = $(this);
      link = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image a')
        .attr("href");
      image = $(data.payload.content)
        .find('.removeable[data-micro-sku="' + get_id + '"] .cart-p-image img')
        .attr("data-src")
        .replace("related", "detail");
      if (!$(this).find(".right").length) {
        $(this).wrapInner('<div class="right"></div>');
        $(this).prepend('<div class="image"><a href="' + link + '"><img src="' + image + '" alt="' + $(this).find('a[data-testid="recapItemName"]').text() + '"></a></div>');
      }
    });
  });
}

if ($(".id--15").length) {
  document.addEventListener("UpsellBannersRendered", function () {
    $(".recapitulation-wrapper").prepend($(".up-banner-wrapper"));
  });
  $("h1").text("Objednávka přijata");
  $("h1").after("<p>Děkujeme za objednávku.</p>");
  $(".reca-number")
    .contents()
    .filter(function () {
      return this.nodeType === 3;
    })
    .first()
    .replaceWith("Číslo objednávky ");

  $('.recapitulation-wrapper[data-testid="recapTable"]').append('<div class="co-box co-extra"></div>');
  $(".co-box.co-extra").append($('.co-box.co-payment-method table tr:not([data-testid="recapCartItem"])'));
  $(".co-box.co-order table tbody tr").each(function () {
    const $row = $(this);
    if ($row.find("strong.for-free").length) {
      $row.closest("tr").addClass("free-gift");
      $row.append('<td class="zdarma"><span>Zdarma</span></td>');
      $row.find("strong.for-free").text("Dárek k objednávce");
      console.log("true");
    }
    const $cell = $row.find("td.p-quantity");
    if (!$cell.length) return;

    const total = parseFloat($cell.find("strong").text().replace(/\s/g, "").replace("Kč", "").replace(",", "."));
    $row.append(`<td class="pricePerSingle"><span>${total} / ks</span></td>`);
  });
}

if ($(".id--16").length) {
  $("#orderFormButton span").text("Pokračovat v objednávce");
  $(document).on("click", "#checkoutSidebar h2.h4", function () {
    $(this).closest(".order-summary-inner").toggleClass("open");
  });
}

function mhProductInfoMove() {
  if ($(".id--9").length) {



    $('.availability-label').each(function () {
      const availabilityText = $(this).text().trim().toLowerCase();
      if (availabilityText.includes("skladem")) {
        $(this).css("color", "#1A9E4A");
      }
    });


    if ($(".extra.delivery span .price-range").length) {
      $(".extra.delivery").append($(".extra.delivery span .price-range").clone());
    }
    let maxDeliveryDate = null;

    function updateMaxDeliveryDateFromAvailability($availabilitySource) {
      if (typeof getDeliveryDateByAvailability !== "function") {
        return;
      }

      const availabilityText = ($availabilitySource.text() || "").replace(/\s+/g, " ").trim();
      if (!availabilityText) {
        return;
      }

      const deliveryDate = getDeliveryDateByAvailability(availabilityText);
      if (!deliveryDate) {
        return;
      }

      if (!maxDeliveryDate || deliveryDate > maxDeliveryDate) {
        maxDeliveryDate = deliveryDate;
      }
    }


    $("tr.removeable").each(function () {
      const $availability = $(this).find(".p-availability");
      $(this).find(".p-name").append($availability.clone());
      $(this).find(".p-total").append($(this).find(".p-price").clone());

      const $availabilityLabel = $availability.find(".availability-label").first();
      updateMaxDeliveryDateFromAvailability($availabilityLabel.length ? $availabilityLabel : $availability);




    });

    // 👉 po dokončení loopu uložíme datum
    if (maxDeliveryDate) {
      const formattedMaxDate = maxDeliveryDate.getDate() + "." + (maxDeliveryDate.getMonth() + 1) + ".";

      localStorage.setItem("maxDeliveryDate", formattedMaxDate);

      console.log("Max delivery date:", formattedMaxDate);
    } else {
      localStorage.removeItem("maxDeliveryDate");
    }

    if ($(".free-gift").length) {
      $(".free-product-gifts li").each(function () {
        $(this).find(".free-gift-label").prepend('<span class="extraText">Dárek k objednávce</span>');
        $(this).find(".free-gift-label").append('<span class="zdarma">Zdarma</span>');
      });
    }

    if ($(".related").length) {
      $(".related .cart-related-product").each(function () {
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-availability"));
        $(this).find(".cart-related-button").prepend($(this).find(".cart-related-name"));
        if ($(this).find('button[type="submit"]').length) {
          $(this).find('button[type="submit"]').text("Koupit");
        }
      });
    }

    const $summaryWrapper = $(".summary-wrapper").first();
    if (!$summaryWrapper.length) {
      return;
    }

    $summaryWrapper.after($(".next-step-back"));
    let $customBox = $summaryWrapper.children(".customBox").first();
    if (!$customBox.length) {
      $summaryWrapper.prepend('<div class="customBox"></div>');
      $customBox = $summaryWrapper.children(".customBox").first();
    }

    if (!$customBox.children("#discount-checkbox").length) {
      $customBox.append(`
          <input type="checkbox" id="discount-checkbox">
              <label for="discount-checkbox">
                  Mám slevový kód
              </label>
          `);
      $customBox.append(
        $(".cart-summary .discount-coupon").clone(),
      );
    }

    const $deliveryInfo = $(".cart-summary .extra.delivery").not($customBox.find(".extra.delivery")).first();
    if ($deliveryInfo.length && !$customBox.children(".extra.delivery").length) {
      $customBox.append($deliveryInfo.clone());
    }

    const $deliveryTime = $(".delivery-time").not($customBox.find(".delivery-time")).first();
    if ($deliveryTime.length && !$customBox.children(".delivery-time").length) {
      $customBox.append($deliveryTime.clone());
    }

    $("#discount-checkbox").on("change", function () {
      $(".discount-coupon").toggleClass("active", this.checked);
    });

    if ($('.discount-coupon .applied-coupon').length) {
      $('.discount-coupon').addClass('active')
      $('#discount-checkbox').prop('checked', true);
      $('input[data-testid="buttonRemoveDiscountCoupon"]').attr('value', 'Odebrat kupon')
    }

    $("#continue-order-button span").text("Pokračovat v objednávce");
  }

  const hasDiscount = $('.cart-table tr.removeable [data-testid="cartItemDiscount"]').length > 0;
  if (hasDiscount) {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt v košíku</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="sale">Sleva</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
    let totalSaved = 0;
    $("tr.removeable").each(function () {
      const $row = $(this);
      const $discountEl = $row.find('[data-testid="cartItemDiscount"]');

      if ($discountEl.length) {
        if (hasDiscount) {
          const title = $row.find(".p-price .show-tooltip").attr("title") || $row.find(".p-price .show-tooltip").attr("data-original-title");
          console.log();
          const percentMatch = title.match(/([\d.,]+)\s?%/);
          const percent = percentMatch ? Math.round(parseFloat(percentMatch[1].replace(",", "."))) : 0;
          const originalMatch = title.match(/standardní ceny\s([\d\s]+)\s?Kč/);
          const originalPrice = originalMatch ? parseInt(originalMatch[1].replace(/\s/g, "")) : 0;
          const finalPrice = parseInt($row.find('[data-testid="cartItemPrice"]').first().text().replace(/\s/g, ""));
          const quantity = parseInt($row.find("input.amount").val()) || 1;
          const savedPerPiece = originalPrice - finalPrice;
          const savedTotal = savedPerPiece * quantity;
          totalSaved += savedTotal;
          $row.find(".p-price").append(`
                    <span class="sale-percent">${percent}%</span>
                `);
          $row.find(".p-total").before(`
                    <td class="p-sale">
                        <span class="sale-percent">${percent}%</span>
                    </td>
                `);
        }
      } else {
        $row.find(".p-total").before('<td class="p-sale"></td>');
      }
    });

    if (totalSaved > 0) {
      $(".price-wrapper").append(`
            <span class="price-label price-secondary" style="color:#118819;">
            Ušetřili jste:
            </span>
            <strong class="price price-secondary" data-testid="recapFullPriceNoVat" style="color:#118819;">
            ${Number(totalSaved).ShoptetFormatAsCurrency()}
            </strong>
        `);
    }
  } else {
    $(".cart-table").prepend(`
        <thead class="table-header">
            <tr>
                <th class="prod" colspan="2">Produkt v košíku</th>
                <th class="avail">Dostupnost</th>
                <th class="qty">Počet</th>
                <th class="unit">Cena za kus</th>
                <th class="total">Celkem</th>
            </tr>
        </thead>
    `);
  }

}

mhProductInfoMove();

document.addEventListener("ShoptetDOMCartContentLoaded", function () {
  requestAnimationFrame(mhProductInfoMove);
});

function emptyCart() {
  $("body").addClass("cartemptycustom");
  $("h1:not(.sr-only), .h1:not(.sr-only)").after($("#footer .emptyCartText"));
}

$("html").on("click", ".customLoginPopup", function (e) {
  e.preventDefault();
  e.stopPropagation();

  $("body").addClass("user-action-visible login-window-visible");
});

